var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Leaflet from 'leaflet';
import 'leaflet-polylinedecorator';
const polylineDecoratorFactory = {
    entityName: 'PolylineDecorator',
    createLayer(state) {
        const { polylineLayer } = state, options = __rest(state, ["polylineLayer"]);
        return Leaflet.polylineDecorator(polylineLayer, options);
    },
    updateLayer(layer, state, nextState) {
        const { polylineLayer, patterns } = nextState;
        if (state.polylineLayer !== polylineLayer)
            layer.setPaths(polylineLayer);
        if (state.patterns !== patterns)
            layer.setPatterns(patterns);
    },
};
export default polylineDecoratorFactory;
